import React from 'react';
import { motion } from 'framer-motion';
import { BiSearch } from 'react-icons/bi';

const Hero = () => (
    <div className="hero">
        <div className="container">
            <div className="row">
                <div className="col-12 col-md-10 col-lg-8 mx-auto">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        transition={{ duration: 0.3 }}
                        variants={{
                            visible: { opacity: 1, y: 0 },
                            hidden: { opacity: 0, y: 20 }
                        }}
                    >
                        <h1 className='display-4'>
                            Search for Products or Services
                        </h1>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.25, delay: 0.25 }}
                    >
                        <p className='lead'>
                            PCSS provides the most comprehensive set of applications, capabilities and services specifically designed to address today’s need for personalized customer experiences at scale.
                        </p>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.25, delay: 0.5 }}
                    >
                        <div className="input-group w-75 mx-auto mt-4">
                            <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Search products or services..."
                                aria-label="Search products or services"
                            />

                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                            >
                                <BiSearch className="fs-5" />
                            </button>
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    </div>
);

export default Hero;